var navScroll = true;
$(document).ready(function () {

    if (window.screen.width >= 1024) {
        new Swiper(".laptopNavImageContainerSwiperDiv", {
            slidesPerView: 'auto',
            preventClicks: 'false',
            spaceBetween: 16,
        });
    }

    var currentUrl = window.location.href;
    if (window.screen.width >= 1024) {

    } else {

    }


    // $(".productMenu").css('width',document.body.clientWidth);
    // if (window.innerWidth >= 1919){
    //     $(".productMenu").css('left',$(".pcHeadNavDiv .newNav").offset().left * -1);
    // }else {
    //     $(".productMenu").css('left',$(".laptopHeadNavDiv .newNav").offset().left * -1);
    // }

    var elementOffset = $('.menu').offset();
    var leftOffset = elementOffset.left * -1;

    var logoDiv;
    logoDiv = $('.pcHeadNavDiv #logoDiv').offset();
    var distanceToBottom = $('.linkTitleLi').position().top + $('.linkTitleLi').outerHeight() - $('.linkTitleLi').parent().outerHeight();

    var totalHeight = 0;

    $('.childLinkTitleDiv-pc').each(function () {
        totalHeight = totalHeight + $(this).actual('outerHeight');
    })
    totalHeight = totalHeight + 10;

    // if (parseInt(logoDiv.left) != 0){
    //     $(".product-dropdown-item").css('margin-left', logoDiv.left +"px");
    // }else {
    //     //13.542vw
    //     $(".product-dropdown-item").css('margin-left', "13.542vw");
    // }


    //$(".nav-image-container").css('left','calc(' + logoDiv.left + 'px + ' + {{section.settings.dropDownSubmenuWidth}} + 'vw)');



    // $(".nav-image-container").css('left','calc(' + logoDiv.left + 'px + 23.6rem' );

    $(".allProduct").css('top', 'calc(' + totalHeight + "px + 2.396vw)");


    if ($(".container.layout--slider").length > 0) {
        $("#productMenu").css('top', '6.6rem')
    } else {
        $("#productMenu").css('top', '6.6rem')
    }

    var element = $('.dropdown-menu');
    // 添加滚轮事件监听器
    element.on('mousewheel DOMMouseScroll', function (event) {
        // 判断滚动方向
        //var delta = event.originalEvent.wheelDelta || -event.originalEvent.detail;

        // 阻止滚动事件的默认行为
        event.preventDefault();
        //event.stopPropagation()
    });

    $("#newNav").on('mousewheel DOMMouseScroll', function (event) {
        // 判断滚动方向
        //var delta = event.originalEvent.wheelDelta || -event.originalEvent.detail;

        // 阻止滚动事件的默认行为
        event.preventDefault();
        //event.stopPropagation()
    });

    var lastScroll = 0;
    $(".nav-image-container").on("wheel", function (event) {

        var targetDiv = $(".nav-image-container").filter(function () {
            if ($(this).css("display") !== "none") {
                return $(this);
            }

        });

        if (targetDiv.length > 0) {
            // 判断是否能滚动
            var canScroll = targetDiv.get(0).scrollHeight > targetDiv.get(0).clientHeight;
            var canScrollHeight = targetDiv.get(0).scrollHeight - targetDiv.get(0).clientHeight;

            // console.log("lastScroll",lastScroll)
            //
            // console.log("scrollHeight",targetDiv.get(0).scrollHeight);
            // console.log("clientHeight",targetDiv.get(0).clientHeight);
            // console.log("scrollNow",targetDiv.scrollTop());
            // console.log("height",targetDiv.height());
            // console.log("prop",targetDiv.prop('scrollHeight'))
            // console.log("e.wheelDelta",event.originalEvent.wheelDelta)


            if (canScroll) {

                if (targetDiv.scrollTop() >= canScrollHeight) {
                    // 判断鼠标是想往上滑还是往下滑
                    if (event.originalEvent.wheelDelta < 0) {
                        event.preventDefault();
                    } else {
                        event.stopPropagation();
                    }
                } else {
                    event.stopPropagation();
                }

            } else {
                event.preventDefault();
            }
            lastScroll = targetDiv.scrollTop();

        } else {
            event.preventDefault();

        }


    });



    changeCurrency();


    function getCurrencyInfo(currencyRate, country) {

        let currencyInfo = [];

        switch (country) {
            case 'US':
                currencyInfo.push('USD');
                currencyInfo.push('$');
                currencyInfo.push(currencyRate.USD)
                break;
            case 'DE':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                currencyInfo.push(currencyRate.EUR)
                break;
            case 'FR':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                currencyInfo.push(currencyRate.EUR)
                break;
            case 'CA':
                currencyInfo.push('CAD');
                currencyInfo.push('$');
                currencyInfo.push(currencyRate.CAD)
                break;
            case 'IT':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                currencyInfo.push(currencyRate.EUR)
                break;
            case 'ES':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                currencyInfo.push(currencyRate.EUR)
                break;
            case 'ES':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                currencyInfo.push(currencyRate.EUR)
                break;
            case 'GB':
                currencyInfo.push('GBP');
                currencyInfo.push('￡');
                currencyInfo.push(currencyRate.GBP)
                break;
            default:
                currencyInfo.push('USD');
                currencyInfo.push('$');
                currencyInfo.push(currencyRate.USD)
                break;
        }

        return currencyInfo;
    }


    function getCurrency(country) {

        let currencyInfo = [];

        switch (country) {
            case 'US':
                currencyInfo.push('USD');
                currencyInfo.push('$');
                break;
            case 'DE':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                break;
            case 'FR':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                break;
            case 'CA':
                currencyInfo.push('CAD');
                currencyInfo.push('$');
                break;
            case 'IT':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                break;
            case 'ES':
                currencyInfo.push('EUR');
                currencyInfo.push('€');
                break;
            case 'GB':
                currencyInfo.push('GBP');
                currencyInfo.push('￡');
                break;
            default:
                currencyInfo.push('USD');
                currencyInfo.push('$');
                break;
        }

        return currencyInfo;
    }

    async function changeCurrency() {
        // 货币转换
        // 替换页面中的所有货币
        $(".notranslate.ht-money").each(function () {
            let self = $(this);
            let symbolAndPicture = $(this).text().trim().split(" ")[0];
            let picture = symbolAndPicture.substring(1, symbolAndPicture.length);

            // console.log($(this).text())

            picture = picture.replaceAll(',', '');

            var oldCountryRate = getCurrencyInfo(JSON.parse(sessionStorage.getItem('currencyRate')), 'US')[2];

            var currentCountryRate = getCurrencyInfo(JSON.parse(sessionStorage.getItem('currencyRate')), sessionStorage.getItem('currentCountry'))[2];

            // 计算新币种价格
            var amount = picture * oldCountryRate / currentCountryRate;

            var currentCountryInfo = getCurrencyInfo(JSON.parse(sessionStorage.getItem('currencyRate')), sessionStorage.getItem('currentCountry'));

            // 检查是否需要币种
            var parent = self.parent();
            var hasClass = parent.hasClass('currencyUNRequired');

            if (hasClass) {
                self.text(currentCountryInfo[1] + amount.toFixed(2))
            } else {
                self.text(currentCountryInfo[1] + amount.toFixed(2) + ' ' + currentCountryInfo[0])
            }

            var originalPrice = parent.hasClass('originalPrice');
            if (originalPrice && currentCountryInfo[0] === 'EUR') {
                self.text('')
            }


        })

        // 选中设置
        if (sessionStorage.getItem('currentCountry') == '' || sessionStorage.getItem('currentCountry') == null || sessionStorage.getItem('country') == '' || sessionStorage.getItem('country') == null) {
            // 如果为空则默认为美国
            $(".activeCountryDiv").text('(USD/US)');
            // 页脚
            $(".footerActiveLangText").text('(USD/US)');
            $("#langShow").html($("#USPhoneImg").html());
        } else {
            // 设置对应所选的国家
            let currencyInfo = getCurrency(sessionStorage.getItem('currentCountry'));
            // console.log('currentCountry',sessionStorage.getItem('currentCountry'))
            // console.log('currencyInfo',currencyInfo);
            $(".activeCountryDiv").text('(' + currencyInfo[0] + '/' + sessionStorage.getItem('country') + ')');
            $(".footerActiveLangText").text('(' + currencyInfo[0] + '/' + sessionStorage.getItem('country') + ')');
            $("#langShow").html($("#" + sessionStorage.getItem('country') + "PhoneImg").html());

        }

        // 首页图标的链接修改
        switch (sessionStorage.getItem('country')) {
            // case 'DE':
            //     $(".logoHref").attr('href','https://cyviolife.com/de-german/' )
            //     break;
            // case 'IT':
            //     $(".logoHref").attr('href','https://cyviolife.com/it-italian/' )
            //     break;
            // case 'FR':
            //     $(".logoHref").attr('href','https://cyviolife.com/fr-french/' )
            //     break;
            // case 'ES':
            //     $(".logoHref").attr('href','https://cyviolife.com/es-spanish/' )
            //     break;
            default:
                $(".logoHref").attr('href', 'https://cyviolife.com/')
        }
    }

    //==============================判断当前页面是否为产品页面====================================
    var currentUrlHeft = window.location.href;
    if (currentUrlHeft.indexOf('products') != -1) {
        if ($.cookie('productHistoricalRecord') != null) {

            var data = JSON.parse($.cookie('productHistoricalRecord'));
            var newData = removeExpiredProductData(data);
            var containFlag = false;
            for (var i = 0; i < newData.length; i++) {
                // 如果存在则更新数据保存时间
                if (newData[i].productId == '{{ product.id }}') {
                    containFlag = true;
                    newData[i].saveDate = new Date().getTime();
                }
            }
            if (!containFlag) {
                newData.unshift({ 'productId': '{{ product.id }}', 'saveDate': new Date().getTime() });
            }
            jqSetCookie('productHistoricalRecord', JSON.stringify(newData), 1);
        } else {
            var data = [];
            data.unshift({ 'productId': '{{ product.id }}', 'saveDate': new Date().getTime() });
            jqSetCookie('productHistoricalRecord', JSON.stringify(data), 1);
        }
    }

});

var newHeadHoverFlag = false;
var searchDivHoverFlag = false;

$(".childLinkTitleDiv-pc").hover(function () {
    //childLinkTitleArrow
    $(this).children(".childLinkTitleArrow").css('display', 'flex');
}, function () {
    $(this).children(".childLinkTitleArrow").css('display', 'none');
})

$(".pcHeadNavDiv").hover(function () {

    if (navScroll) {
        $("#newHead").css('box-shadow', 'none');
    }

}, function () {
    if (navScroll) {
        $("#newHead").css('background-color', 'transparent');
    } else {
        $("#newHead").css('background-color', '#FFFFFF');
        $("#newHead").css('box-shadow', '0vw 0.5vw 0.2vw -0.6vw #333333');
    }

    $("#searchDiv").css('display', 'none');
})

// 产品页 产品系列块显隐
function showImage(index) {
    var image;
    image = document.querySelector("#nav-image-container-" + index);

    var images = document.querySelectorAll('.nav-image-container');
    images.forEach(function (img) {
        img.style.display = 'none';

    });
    if (image) {
        image.style.display = 'flex';
    }

}

function showSearchDiv(e) {

    $("#searchDiv").toggle();

    if ($("#searchDiv").css('display') == 'none') {
        $("#newHead").css('background-color', 'transparent');
    } else {
        $("#newHead").css('background-color', '{{ section.settings.headerBackgroundColor }}');
    }
}

function changeLocation(e, type) {

    e.preventDefault();

    let countryInfo = getCountry(type);
    let href = getHref();


    // 修改链接为所选择语言的链接
    let currentHref = window.location.href;
    let split = currentHref.split('cyviolife.com');

    let localeCode = '';
    let language = '';
    if (countryInfo[1] != 'en') {
        localeCode = countryInfo[1];
        language = countryInfo[2];
    }

    // console.log("Currency",Currency)
    // console.log(localStorage.getItem('globalVariable'));
    // 设置切换的国家及币种
    sessionStorage.setItem('country', type);
    sessionStorage.setItem('currentCountry', countryInfo[0]);
    if (href.indexOf('/') == 0) {

        if (localeCode != '') {
            window.location.href = split[0] + 'cyviolife.com/' + localeCode + '-' + language + href;
        } else {
            window.location.href = split[0] + 'cyviolife.com' + href;
        }

    } else {
        if (localeCode != '') {
            window.location.href = split[0] + 'cyviolife.com/' + localeCode + '-' + language + '/' + href;
        } else {
            window.location.href = split[0] + 'cyviolife.com/' + href;
        }
    }

    // $.ajax({
    //     url:"https://cyviolife.com/localization",
    //     type : 'post',
    //     async: true,
    //     data : {
    //         _method: 'PUT',
    //         return_to: href,
    //         country_code:countryInfo[0],
    //         locale_code:countryInfo[1]
    //     },
    //     success : function(data) {
    //
    //
    //
    //     }
    // })

}

// 获取所选国家信息
function getCountry(type) {

    let countryInfo = [];
    let countryCode = '';
    let localeCode = '';
    let language = '';

    if (type == 'US') {
        countryCode = 'US';
        localeCode = 'en'
        language = 'english';
    }

    if (type == 'CA') {
        countryCode = 'CA';
        localeCode = 'en';
        language = 'english';
    }

    if (type == 'FR') {
        countryCode = 'FR';
        localeCode = 'en'
        language = 'english';
    }

    if (type == 'DE') {
        countryCode = 'DE';
        localeCode = 'en'
        language = 'english';
    }

    if (type == 'IT') {
        countryCode = 'IT';
        localeCode = 'en'
        language = 'english';
    }

    if (type == 'ES') {
        countryCode = 'ES';
        localeCode = 'en'
        language = 'english';

    }

    if (type == 'UK') {
        countryCode = 'GB';
        localeCode = 'en';
        language = 'english';
    }


    countryInfo.push(countryCode);
    countryInfo.push(localeCode);
    countryInfo.push(language)

    return countryInfo;
}

// 获取链接
function getHref() {
    // 本地链接
    let currentHref = window.location.href;

    if (currentHref.search('/fr-french/') != -1) {
        return currentHref.split('/fr-french/')[1];
    } else if (currentHref.search('/fr-french') != -1) {
        return currentHref.split('/fr-french')[1];
    } else if (currentHref.search('/de-german/') != -1) {
        return currentHref.split('/de-german/')[1];
    } else if (currentHref.search('/de-german') != -1) {
        return currentHref.split('/de-german')[1];
    } else if (currentHref.search('/it-italian/') != -1) {
        return currentHref.split('/it-italian/')[1];
    } else if (currentHref.search('/it-italian') != -1) {
        return currentHref.split('/it-italian')[1];
    } else if (currentHref.search('/es-spanish/') != -1) {
        return currentHref.split('/es-spanish/')[1];
    } else if (currentHref.search('/es-spanish') != -1) {
        return currentHref.split('/es-spanish')[1];
    } else {
        return window.location.pathname;
    }
}

$(window).resize(function () {

    if (window.screen.width >= 1024) {
        var swiper = new Swiper(".laptopNavImageContainerSwiperDiv", {
            slidesPerView: 'auto',
            preventClicks: 'false',
            spaceBetween: 16,
        });
    }

    var currentUrl = window.location.href;
    // if (window.screen.width >= 1024){
    //     if (currentUrl.indexOf('products') !== -1 || currentUrl.indexOf('pages') !== -1){
    //         $("#MainContent").css('background-color','#FFFFFF');
    //         $("body").css('background-color','#FFFFFF');
    //     }else{
    //         $("#MainContent").css('background-color','#F1F4F4');
    //         $("body").css('background-color','#F1F4F4');
    //     }
    // }else {
    //     $("#MainContent").css('background-color','#FFFFFF');
    //     $("body").css('background-color','#FFFFFF');
    // }

    var totalHeight = 0;

    $('.childLinkTitleDiv-pc').each(function () {
        totalHeight = totalHeight + $(this).actual('outerHeight');
    })
    totalHeight = totalHeight + 10;

    $(".allProduct").css('top', 'calc(' + totalHeight + "px + 2.396vw)");


    if ($(".container.layout--slider").length > 0) {
        $("#productMenu").css('top', '6.6rem')
    } else {
        $("#productMenu").css('top', '6.6rem')
    }
});

// 判断滚轮位置 导航栏固定于顶部设置
$(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();

    var threshold = $("#newHead").height(); // 指定的阈值位置

    if (scrollPosition > threshold) {
        navScroll = false;
        // 滚动位置超过阈值的处理逻辑
        if (window.innerWidth >= 1024) {
            $(".pcHeadNavDiv #newHead").css('position', 'fixed');
            $(".pcHeadNavDiv #newHead").css('top', '0');
            $(".pcHeadNavDiv #newHead").css('background-color', '#FFFFFF');
            $(".pcHeadNavDiv #newHead").css('box-shadow', '0vw 0.5vw 0.2vw -0.6vw #333333');
            $(".menuTitle").css('color', '#333333');
            $(".pcHeadNavDiv #searchDiv").css('position', 'fixed');
            $(".pcHeadNavDiv #searchDiv").css('top', '6.6rem');
        } else {
            $(".menuTitle").css('color', '#333333');
        }


    } else {
        // 滚动位置未超过阈值的处理逻辑
        if (window.innerWidth >= 1024) {
            $(".pcHeadNavDiv #newHead").css('position', 'relative');
            $(".pcHeadNavDiv #newHead").css('top', '0vw');
            $(".pcHeadNavDiv #newHead").css('background-color', 'transparent');
            $(".menuTitle").css('color', '#333333');
            $(".pcHeadNavDiv #searchDiv").css('position', 'absolute');
            $(".pcHeadNavDiv #searchDiv").css('top', '10.6rem');
            $(".pcHeadNavDiv #newHead").css('box-shadow', 'none');
            navScroll = true;
        } else {
            $(".menuTitle").css('color', '#333333');
        }

    }
});

// 设置跳转筛选cookie值
function setSkipCookie(productSeries) {
    jqSetCookie('productSeries', productSeries, 1);
    window.location = '/pages/productfilter';
}

// 产品页导航栏透明黑底显隐
$(".menu-item_product").hover(function () {
    $(".pcMask").css('opacity', '1');
}, function () {
    $(".pcMask").css('opacity', '0');
})